import { IDB_deleteAll, IDB_rowRead, IDB_rowsDelete, IDB_rowsReadAll, IDB_rowsWrite } from './IDB.queries'
import { IDB_globalDb } from './IDB'
import type { Type_ITaskReport } from '../Type/Type.hive'

export function IDB_taskReportRead(id: number) {
    return IDB_rowRead<Type_ITaskReport>(IDB_globalDb, 'task_report', id)
}

export function IDB_taskReportsDelete(ids: number[]) {
    return IDB_rowsDelete(IDB_globalDb, 'task_report', ids)
}

export function IDB_taskReportsDeleteAll() {
    return IDB_deleteAll(IDB_globalDb, 'task_report')
}

export function IDB_taskReportsReadAll() {
    return IDB_rowsReadAll<Type_ITaskReport>(IDB_globalDb, 'task_report')
}

export function IDB_taskReportsWrite(taskReports: Type_ITaskReport[]) {
    return IDB_rowsWrite(IDB_globalDb, 'task_report', taskReports)
}
